<template>
  <base-select
    v-model="typeOfIssue"
    borderless
    class="w-full"
    content-class="w-full"
    toggle-color="brand"
    placeholder="Type of Issue"
    :options="options"
    v-bind="$attrs"
  >
    <template #toggle="{ active }">
      <div class="truncate w-40 -mr-8 pr-3">
        {{ active.label }}
      </div>
    </template>
    <template #label="{props}">
      <div class="break-all">
        {{ props.label }}
      </div>
    </template>
  </base-select>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
  inheritAttrs: false,
  computed: {
    ...mapGetters({
      currentTask: 'tasks/getCurrentTask',
      getColumns: 'board-column/getSortedColumns'
    }),
    typeOfIssue: {
      get() {
        return this.task?.typeOfIssue;
      },
      set(typeOfIssue) {
        if (this.task.typeOfIssue != typeOfIssue)
          this.setTask({
            id: this.task?.id,
            typeOfIssue
          });
      }
    },
    task() {
      return this.currentTask;
    },
    columns() {
      return this.getColumns;
    },
    options() {
      return [
        { label: 'Task', value: 'TASK' },
        { label: 'Defect', value: 'DEFECT' },
        { label: 'Quality Check (QC)', value: 'QC' }
      ];
    }
  },
  methods: {
    ...mapActions({
      setTask: 'tasks/setTask'
    })
  }
});
</script>

<style></style>
